import { render, staticRenderFns } from "./TaxDeclarations.vue?vue&type=template&id=3a8f8895&scoped=true&"
import script from "./TaxDeclarations.vue?vue&type=script&lang=ts&"
export * from "./TaxDeclarations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f8895",
  null
  
)

export default component.exports